import { gql } from '@apollo/client';

export const getCheckoutHealthOfferPayment = gql`query checkoutHealthOfferPaymentOptions($offerId: String!, $soId: String!) {
  checkoutHealthOfferPaymentOptions(offerId: $offerId) {
      offer {
          status
          brandId
          supplementary {
            label
            brandName
            brandCode
            code
            total {
              generalTransfer
              generalTransferWithInstallments
              creditCard
              creditCardWithInstallments
            }
            actionLabel
          }
          additional {
            label
            brandName
            brandCode
            code
            total {
              generalTransfer
              generalTransferWithInstallments
              creditCard
              creditCardWithInstallments
            }
          }
      }
      paymentOptions {
        paymentOption
        paymentTypes {
          paymentType
          paymentTypeLabel
          installments {
            installment
            amount
            paymentTypeDiscount
          }
        }
        paymentSlipInfo {
           amount
           numOfInstallments
         }
      }
    },
    checkoutHealthOfferGeneralTransferDetailsOneTime: checkoutHealthOfferGeneralTransferDetails(offerId: $offerId, installments: 1) {
      price
      customerFirstName
      customerLastName
      customerAddress
      customerCity
      customerZipCode
      customerCountry
      customerPhone
      customerEmail
      customerOib
      recipientAccountNumber
      recipientAddress
      recipientCity
      recipientZipCode
      recipientName
      referenceNumber
      referenceNumberType
      referencePrefix
      referenceSuffix
      model
      description
      numberOfInstallments
    },
    checkoutHealthOfferGeneralTransferDetailsInstallments: checkoutHealthOfferGeneralTransferDetails(offerId: $offerId, installments: 12) {
      price
      customerFirstName
      customerLastName
      customerAddress
      customerCity
      customerZipCode
      customerCountry
      customerPhone
      customerEmail
      customerOib
      recipientAccountNumber
      recipientAddress
      recipientCity
      recipientZipCode
      recipientName
      referenceNumber
      referenceNumberType
      referencePrefix
      referenceSuffix
      model
      description
      numberOfInstallments
    },
    checkoutHealthOffer(id: $offerId) {
      _id
      soId
      status
      brandId
      supplementary {
        label
        actionLabel
        brandName
        brandCode
        priceChangeModifier {
          amount
          type
          description
        }
        voucherPriceModifier{
          amount
        }
        voucherPriceChangeModifier{
          amount
          type
          description
          code
        }
        numberOfInstallments
        code
        visual {
          highlight
          tooltip
          description
        }
        logoUrl
        fixedCoverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        coverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        discounts {
          value
          tooltip
        }
        paymentSlipInfo {
          amount
          numOfInstallments
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
      }
      additional {
        label
        brandName
        brandCode
        priceChangeModifier {
          amount
          type
          description
        }
        voucherPriceModifier{
          amount
        }
        numberOfInstallments
        code
        visual {
          highlight
          tooltip
          description
        }
        logoUrl
        coverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        fixedCoverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        discounts {
          value
          tooltip
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
      annotations
    },
    overflowVoucherStatus {
      active
      voucherCode
      voucherValue
      voucherDescription
    }
    personalVoucherStatus(soId: $soId) {
      value
      code
      type
      description
      campaignName
      name
      generatedUniqueCodes
      startDate
      endDate
      status
    }
}`;
